import type { Theme } from '@mui/material';

// import type { Components } from '@mui/material/styles';
import { RootContainers } from '@/modules/common/helpers';

export default function MUIPopper(theme: Theme) /* : Components['MuiPopper'] */ {
  return {
    defaultProps: {
      container: RootContainers.getMUIPortalContainer(),
      // disableScrollLock: true,
      placement: 'bottom-start',
    },
    styleOverrides: {
      root: {
        zIndex: theme.zIndex.modal,
      },
    },
  };
}
